import { render, staticRenderFns } from "./Error2Dialog.vue?vue&type=template&id=0896e384&"
import script from "./Error2Dialog.vue?vue&type=script&lang=js&"
export * from "./Error2Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports